import DialogflowMessenger from "../components/DialogflowMessenger";
import NavBar from "../components/NavBar";
import PersonalInsights from "../components/PersonaInsights";
import React from "react";
import SideNavbar from "../components/SideNavbar";
import styled from "styled-components";

const FlexDiv = styled.div`
  display: flex;
  justify-content: space-between;
  background-color: #f7f7f8;
`;

const Home = () => {
  return (
    <div>
      <NavBar />
      <FlexDiv>
        <SideNavbar />
        <PersonalInsights />
        <DialogflowMessenger />
      </FlexDiv>
    </div>
  );
};

export default Home;
